"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLeftButtons = exports.StyledRightButtons = exports.StyledForm = exports.StyledFormFooter = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _formField = _interopRequireDefault(require("../../__internal__/form-field/form-field.style"));

var _fieldset = require("../../__internal__/fieldset/fieldset.style");

var _button = _interopRequireDefault(require("../button/button.style"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _fieldset2 = require("../fieldset/fieldset.style");

var _inlineInputs = _interopRequireDefault(require("../inline-inputs/inline-inputs.style"));

var _form = require("./form.config");

var _search = _interopRequireDefault(require("../search/search.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FormButtonAnimation = (0, _styledComponents.keyframes)`
  0%   { transform: translateY(50px); }
  100% { transform: translateY(0px); }
`;
const StyledFormFooter = _styledComponents.default.div`
  margin-top: 48px;
  align-items: center;
  display: flex;

  ${({
  buttonAlignment
}) => buttonAlignment === "right" && (0, _styledComponents.css)`
      justify-content: flex-end;
    `}

  ${({
  stickyFooter,
  theme
}) => (0, _styledComponents.css)`
    ${stickyFooter && (0, _styledComponents.css)`
      animation: ${FormButtonAnimation} 0.25s ease;
      background-color: ${theme.colors.white};
      box-shadow: 0 -4px 12px 0 rgba(0, 0, 0, 0.05);
      box-sizing: border-box;
      padding: 16px 32px;
      bottom: 0;
      left: 0;
      position: fixed;
      width: 100%;
      z-index: 1000;
    `}
  `}
`;
exports.StyledFormFooter = StyledFormFooter;
const StyledForm = _styledComponents.default.form`
  ${_styledSystem.space}

  & ${_formField.default}, ${_fieldset.StyledFieldset}, ${_fieldset2.FieldsetStyle}, > ${_button.default} {
    margin-top: 0;
    margin-bottom: ${({
  fieldSpacing,
  theme
}) => theme.spacing * fieldSpacing}px;
  }

  ${_inlineInputs.default} {
    ${_formField.default} {
      margin-bottom: 0;
    }

    margin-bottom: ${({
  fieldSpacing,
  theme
}) => theme.spacing * fieldSpacing}px;
  }

  ${_search.default} ${_formField.default} {
    margin-bottom: 0px;
  }

  ${({
  stickyFooter,
  isInSidebar
}) => stickyFooter && (0, _styledComponents.css)`
      padding-bottom: 88px;

      ${isInSidebar && (0, _styledComponents.css)`
        // important keyword is needed because original style is provided in inline style mode
        position: static !important;

        ${StyledFormFooter} {
          position: absolute;
        }
      `}
    `}
`;
exports.StyledForm = StyledForm;
const StyledRightButtons = _styledComponents.default.div`
  display: flex;
  margin-left: 16px;
  ${({
  buttonAlignment
}) => buttonAlignment === "left" && "flex-grow: 1"};

  ${_button.default}:last-child {
    margin-right: 0;
  }
`;
exports.StyledRightButtons = StyledRightButtons;
const StyledLeftButtons = _styledComponents.default.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 16px;
  ${({
  buttonAlignment
}) => buttonAlignment === "right" && "flex-grow: 1"};

  ${_button.default}:last-child {
    margin-right: 0;
  }
`;
exports.StyledLeftButtons = StyledLeftButtons;
StyledForm.propTypes = {
  theme: _propTypes.default.object,
  stickyFooter: _propTypes.default.bool,
  fieldSpacing: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 7])
};
StyledForm.defaultProps = {
  theme: _base.default
};
StyledLeftButtons.propTypes = {
  buttonAlignment: _propTypes.default.oneOf(_form.FORM_BUTTON_ALIGNMENTS)
};
StyledRightButtons.propTypes = {
  buttonAlignment: _propTypes.default.oneOf(_form.FORM_BUTTON_ALIGNMENTS)
};
StyledFormFooter.propTypes = {
  theme: _propTypes.default.object,
  buttonAlignment: _propTypes.default.oneOf(_form.FORM_BUTTON_ALIGNMENTS),
  stickyFooter: _propTypes.default.bool
};
StyledFormFooter.defaultProps = {
  theme: _base.default
};